import Component from "@glimmer/component";
import { cached } from "@glimmer/tracking";
import { on } from "@ember/modifier";
import { LinkTo } from "@ember/routing";
import { or } from "ember-truth-helpers";
import mergeClasses from "glesys-controlpanel/modifiers/merge-classes";

export interface LinkItemSignature {
  Args: {
    route?: string;
    model?: unknown;
    models?: unknown[];
    query?: Record<string, unknown>;
    disabled?: boolean;
  };
  Blocks: {
    default: [];
  };
  Element: HTMLAnchorElement;
}

export default class extends Component<LinkItemSignature> {
  get models() {
    const models = this.args.model ? [this.args.model] : this.args.models;
    return models ?? [];
  }

  @cached
  get query() {
    return this.args.query ?? {};
  }

  handlePossiblyDisabledClick = (event: MouseEvent) => {
    if (this.args.disabled) {
      event.preventDefault();
      event.stopPropagation();
    }
  };

  get classes() {
    return `w-full px-2.5 py-2.5 pr-8 whitespace-nowrap text-sm text-gray-800 hover:text-black flex items-center focus:bg-gray-200 hover:bg-gray-200
          ${this.args.disabled ? "cursor-not-allowed opacity-50" : "cursor-pointer"}`;
  }

  <template>
    {{#if @route}}
      <LinkTo
        class={{this.classes}}
        role="menuitem"
        aria-disabled={{if @disabled "true" "false"}}
        @route={{@route}}
        @models={{this.models}}
        @query={{this.query}}
        @disabled={{@disabled}}
        tabindex={{if @disabled "-1"}}
        {{on "click" this.handlePossiblyDisabledClick}}
        {{mergeClasses}}
        ...attributes
      >
        {{yield}}
      </LinkTo>
    {{else if (or @query this.models)}}
      <LinkTo
        class={{this.classes}}
        role="menuitem"
        aria-disabled={{if @disabled "true" "false"}}
        @query={{this.query}}
        @models={{this.models}}
        @disabled={{@disabled}}
        tabindex={{if @disabled "-1"}}
        {{on "click" this.handlePossiblyDisabledClick}}
        {{mergeClasses}}
        ...attributes
      >
        {{yield}}
      </LinkTo>
    {{else}}
      <a
        class={{this.classes}}
        role="menuitem"
        aria-disabled={{if @disabled "true" "false"}}
        href=""
        tabindex={{if @disabled "-1"}}
        {{on "click" this.handlePossiblyDisabledClick}}
        {{mergeClasses}}
        ...attributes
      >{{yield}}</a>
    {{/if}}
  </template>
}
